import {
    CertificateOfOriginState
} from "./types";
import {RootState} from "@/store/types";
import {Module, MutationTree, GetterTree, ActionTree} from "vuex";
import {getProductMaterialDeterminationsByItemIds} from "@/services/product_determination";
import {saveCertificateOfOrigin, getCertificatesOfOrigin, getCertificateToDownload} from "@/services/origin_determination_certificate"; 

export const state: CertificateOfOriginState = {
    generate_button_status: {
        status: true
    },
    closing_month: {
        date: ''
    }
}

const actions: ActionTree<CertificateOfOriginState, RootState> = {
    async GET_DETERMINED_PRODUCTS(_, payload) {
      return await getProductMaterialDeterminationsByItemIds(payload);
    },
    async GET_CERTIFICATES_OF_ORIGIN(_, payload) {
        return await getCertificatesOfOrigin(payload);
    },
    async SAVE_CERTIFICATE_OF_ORIGIN(_, customer) {
        await saveCertificateOfOrigin(customer);
    },
    async GET_CERTIFICATE_TO_DOWNLOAD(_, payload) {
        return await getCertificateToDownload(payload);
    }
}

const mutations: MutationTree<CertificateOfOriginState> = {
    SET_GENERATE_BUTTON_STATUS(state, status: boolean) {
        state.generate_button_status.status = status;
    },
    SET_CLOSING_MONTH_DATE(state, date: string) {
        state.closing_month.date = date;
    }
}

const getters: GetterTree<CertificateOfOriginState, RootState> = {
    GENERATE_BUTTON_STATUS(state): boolean  {
      return state.generate_button_status.status;
    },
    CLOSING_MONTH_DATE(state): string  {
        return state.closing_month.date;
      },
}

export const certificate_of_origin: Module<CertificateOfOriginState, RootState> = {
    state,
    mutations,
    getters,
    actions
}